<template>
  <a-card :bordered="false">
    <a-steps class="steps" :current="currentTab">
      <a-step title="住宿基础信息" />
      <a-step title="住宿房型信息" />
      <a-step title="住宿详情信息" />
    </a-steps>
    <div class="content">
      <step1 v-show="currentTab === 0" @nextStep="nextStep" @updateGoods="updateGoods"/>
      <step2 v-show="currentTab === 1" @nextStep="nextStep" :goodsId="goods.id" :currentTab="currentTab" @prevStep="prevStep"/>
      <step3 v-show="currentTab === 2" @prevStep="prevStep" :goodsId="goods.id" :currentTab="currentTab" @finish="finish"/>
    </div>
  </a-card>
</template>

<script>
  import Step1 from './GoodsFormStep1.vue'
  import Step2 from './GoodsFormStep2'
  import Step3 from './GoodsFormStep3'

  export default {
    name: 'StepForm',
    components: {
      Step1,
      Step2,
      Step3
    },
    data () {
      return {
        currentTab: 0,
        // form
        form: null,
        goods:{
          id:this.$route.query.id
        }
      }
    },
    methods: {
      // handler
      updateGoods(goods){
        this.goods = goods
      },
      nextStep () {
        if (this.currentTab < 2) {
          this.currentTab += 1
        }
      },
      prevStep () {
        if (this.currentTab > 0) {
          this.currentTab -= 1
        }
      },
      finish () {
        this.currentTab = 0
      }
    }
  }
</script>

<style lang="less" scoped>
  .steps {
    max-width: 750px;
    margin: 16px auto;
  }
</style>